module.exports = __webpack_public_path__ + "static/media/buy_pause_payment_7.7549095f.jpg";